<template>
  <v-row align="center" justify="center" class="mt-2 container-order">
    <v-card width="500" max-width="90%" elevation="7" class="rounded">
      <v-card-text>
        <v-row class="d-flex align-center justify-center">
          <!-- <v-col cols="6">
            <v-btn block>
              <img src="../assets/estacionario.svg" width="5%" class="ma-1" />
              Estacionario
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn block>
              <img src="../assets/cilindro.svg" width="5%" class="ma-1" />
              Cilindro
            </v-btn>
          </v-col> -->
          <!-- {{tipoServicio}}
          <v-btn-toggle v-model="tipoServicio" color="secondary" mandatory>
            <v-btn :color="secondary">
              <img src="../assets/estacionario.svg" width="5%" class="ma-1" />
              Estacionario
            </v-btn>
            <v-btn>
              <img src="../assets/cilindro.svg" width="5%" class="ma-1" />
              Cilindro
            </v-btn>
          </v-btn-toggle> -->

          <v-radio-group v-model="formOkBoy.tipoServicio" row>
            <div class="row">
              <v-radio color="secondary" value="Estacionario" @click="clickProduct()">>
                <template v-slot:label>
                  <div class="d-flex align-center">
                    Estacionario
                    <img
                      src="../assets/estacionario.svg"
                      width="50"
                      class="ml-2"
                    />
                  </div>
                </template>
              </v-radio>
              <v-radio color="secondary" value="Cilindro" @click="clickProduct()">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    Cilindro
                    <img src="../assets/cilindro.svg" width="30" class="ml-2" />
                  </div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </v-row>
        <v-form ref="form">
          <v-row align="center" justify="center">
            <v-col cols="11">
              <v-row
                align="center"
                justify="center"
                v-if="formOkBoy.tipoServicio === 'Estacionario'"
              >
                <v-select
                  v-model="formOkBoy.cantidadGasEstacionario"
                  :items="montosEstacionario"
                  label="Selecciona una cantidad"
                  prepend-icon="mdi-currency-usd"
                   @input="cantidad"
                ></v-select>

                <v-text-field
                  v-if="formOkBoy.cantidadGasEstacionario === 'Otra'"
                  v-model="otraCantidadEstacionario"
                  label="Introduce una cantidad"
                  prepend-icon="mdi-currency-usd"
                  :rules="estacionarioRules"
                ></v-text-field>
              </v-row>
              <v-row
                align="center"
                justify="center"
                v-if="formOkBoy.tipoServicio === 'Cilindro'"
              >
                <v-select
                  v-model="formOkBoy.tipoGasCilindro"
                  :items="precioCilindros"
                  item-text="peso"
                  item-value="peso"
                  label="Selecciona un tamaño"
                  prepend-icon="mdi-gas-cylinder"
                ></v-select>
              </v-row>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-btn block class="buttonPrimary" @click="toForm()">
              Pedir gas
              <!-- <img src="../assets/flame.png" width="5%" class="ma-1" /> -->
              <v-icon color="red">mdi-fire</v-icon>
            </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-row>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import precioCilindros from "../statics/cylinderGasPrice.json";
import axios from "axios";

var mixpanel = require('mixpanel-browser');
import config from "../config"
mixpanel.init(config.key);

export default {
  computed: {
    ...mapFields(["formOkBoy", "showMessage", "message"]),
  },
  data() {
    return {
      tipoServicio: undefined,
      precioCilindros,
      otraCantidadEstacionario: null,
      montosEstacionario: [],
      estacionarioRules: [
        (v) => !!v || "La cantidad es requerida.", //
        (v) => parseInt(v) !== 0 || "La cantidad debe ser mayor a 0", //
        (v) => RegExp("[0-9]+$").test(v) || "Ingresa sólo números",
      ],
    };
  },
  methods: {
    toForm() {
      if (this.$refs.form.validate()) {
        if (this.formOkBoy.tipoServicio === "Cilindro") {
          for (let i = 0; i < this.precioCilindros.length; i++) {
            if (this.formOkBoy.tipoGasCilindro === this.precioCilindros[i].peso) {
              this.formOkBoy.montoTotalGas = this.precioCilindros[i].precio;
              this.formOkBoy.cantidadGasCilindro = this.precioCilindros[i].precio;
              this.formOkBoy.productShowcaseUuid = this.precioCilindros[i].productShowcaseUuid
            }
          }
          mixpanel.track(`Click Pedir Gas`);
          this.$router.push({ name: "GasOrder" });
        } else {
          if (this.formOkBoy.cantidadGasEstacionario === "Otra") {
            if (this.otraCantidadEstacionario >= 500) { 
              this.formOkBoy.cantidadGasEstacionario = this.otraCantidadEstacionario;
              this.formOkBoy.montoTotalGas = this.formOkBoy.cantidadGasEstacionario;
              this.$router.push({ name: "GasOrder" });
            } else {
              this.showMessage = true;
              this.message = "La cantidad mínima debe ser $500.00";
            }
          } else {
            this.formOkBoy.montoTotalGas = this.formOkBoy.cantidadGasEstacionario;
            mixpanel.track(`Click Pedir Gas`);
            this.$router.push({ name: "GasOrder" });
          }
          this.formOkBoy.productShowcaseUuid = "a05a2e9d-b113-4cbb-971b-6cb0d355c548"
        }
      }
    },
    getMounts() {
      let api = axios
        .get(config.apiBaseUrl + "/services/amounts", {
          headers: {
            "x-api-key": config.apiKey,
          },
        })
        .then((response) => {
          this.montosEstacionario = response.data.amounts;
          this.montosEstacionario.push("Otra");
          this.formOkBoy.cantidadGasEstacionario = response.data.popular;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    clickProduct(){
      mixpanel.track(`Seleccionó ${this.formOkBoy.tipoServicio}`);
    },
    cantidad(value){
      mixpanel.track(`Seleccionó Cantidad`, {'tipo de servicio ': this.formOkBoy.tipoServicio, 'cantidad':  value});
    }
  },
  mounted() {
    this.getMounts();
  },
};
</script>

<style scoped>
.rounded {
  border-radius: 10px !important;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
    height: 48px;
    min-height: 0;
    min-width: 48px;
    max-width: 50%;
    width: 50%!important;
}
@media screen and (max-width: 600px) {
  .container-order {
    margin-top: 3em !important;
  }
}

</style>